import axios, { AxiosRequestConfig } from '@sas/nova-core/axios';

// REST helper functions
export const fetchBody = async (axiosConfig: AxiosRequestConfig) => {
  const response = await axios(axiosConfig);
  return response.data;
};
